import script from "./TextHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./TextHeader.vue?vue&type=script&setup=true&lang=js"

import "./TextHeader.vue?vue&type=style&index=0&id=2d32a638&scoped=true&lang=css"

import exportComponent from "/home/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d32a638"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon});
